<template>
  <v-container
    id="Usuario"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="6"
      >
        <v-slide-y-transition appear>
          <v-card
            class="pa-3 pa-md-5 mx-auto"
            light
          >
            <div>
              <div id="imagem">
                <v-img
                  :src="imagem"
                />
              </div>
              <pages-heading
                class="text-center text-h2"
                :style="styleObject"
              >
                Cadastro de Cliente
              </pages-heading>
              <div
                v-if="usuarioBloqueado"
              >
                <div
                  class="transition-swing font-weight-light text-center text-h3"
                  v-text="usuarioInativo"
                /> <br>
                <v-btn
                  id="idSuport2"
                  :color="corPrimaria"
                  dark
                  class="col-3 col-sm-4"
                  target="_blank"
                  :href="whatsapp"
                  @click="reload()"
                >
                  <v-icon
                    id="iconSuport"
                    color="#ffffff"
                  >
                    mdi-account-question
                  </v-icon>
                  <h5>SUPORTE</h5>
                </v-btn><br>
                <!-- <span class="text-center">
                  <router-link
                    :to="{name: 'Registrar', params: {tokencontrato: tokencontrato}}"
                    :style="styleObject"
                  >Solucionou, retorne para fazer o cadastro</router-link>
                </span> -->
              </div>
              <div
                v-else
              >
                <validation-observer v-slot="{ invalid }">
                  <v-form
                    ref="form"
                    v-model="valid"
                    @submit.prevent="salvar"
                  >
                    <v-row class="text-center">
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <div class="my-2" />
                        <v-chip
                          :outlined="!exibePf"
                          :color="corPrimaria"
                          @click="exibePessoa('f')"
                        >
                          Pessoa Física
                        </v-chip>
                        <v-chip
                          :outlined="exibePf"
                          :color="corPrimaria"
                          @click="exibePessoa('j')"
                        >
                          Pessoa Jurídica
                        </v-chip>
                        <tex-field-with-validation
                          v-if="exibePf"
                          v-model="usuario.cpf"
                          v-mask="maskcpf"
                          :color="corPrimaria"
                          class="text-h6"
                          rules="required"
                          type="tel"
                          label="CPF"
                          prepend-inner-icon="mdi-account"
                        />
                        <tex-field-with-validation
                          v-else
                          v-model="usuario.cnpj"
                          v-mask="maskcnpj"
                          :color="corPrimaria"
                          class="text-h6"
                          rules="required"
                          type="tel"
                          label="CNPJ"
                          prepend-inner-icon="mdi-account"
                        />
                        <!-- :color="corPrimaria" -->
                        <tex-field-with-validation
                          :value="usuario.email"
                          class="text-h6"
                          rules="email"
                          required
                          type="email"
                          label="Email"
                          prepend-inner-icon="mdi-email-fast"
                          :style="styleObject"
                          @input="(value) => { usuario.email = value }"
                        />
                        <tex-field-with-validation
                          v-model="usuario.password"
                          :color="corPrimaria"
                          class="text-h6"
                          rules="required"
                          :type="inputType ? 'text' : 'password'"
                          label="Senha"
                          prepend-inner-icon="mdi-lock"
                          :append-icon="inputType ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="inputType = !inputType"
                        />
                        <tex-field-with-validation
                          v-model="usuario.repetepassword"
                          :color="corPrimaria"
                          class="text-h6"
                          rules="required"
                          :type="inputType1 ? 'text' : 'password'"
                          label="Repetir Senha"
                          prepend-inner-icon="mdi-lock"
                          :append-icon="inputType1 ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="inputType1 = !inputType1"
                        />
                      </v-col>
                    </v-row>
                    <div v-if="cadastrook">
                      <pages-heading
                        class="text-center text-h2"
                        :style="styleObject"
                      >
                        Finalize seu cadastro
                      </pages-heading>
                      <pages-heading
                        class="text-center text-h5"
                        :style="styleObject"
                      >
                        {{ nomeEmpresa }}
                      </pages-heading>
                      <tex-field-with-validation
                        v-model="usuario.nome"
                        :color="corPrimaria"
                        class="text-h6"
                        rules="required"
                        type="text"
                        label="Nome"
                        prepend-inner-icon="mdi-account"
                      />
                      <tex-field-with-validation
                        v-model="usuario.razaosocial"
                        :color="corPrimaria"
                        class="text-h6"
                        rules="required"
                        type="text"
                        label="Razão Social"
                        prepend-inner-icon="mdi-account"
                      />
                      <tex-field-with-validation
                        v-model="usuario.telefone"
                        v-mask="maskphone"
                        :color="corPrimaria"
                        class="text-h6"
                        rules="required"
                        type="tel"
                        label="Telefone"
                        prepend-inner-icon="mdi-phone-outline"
                      />
                      <v-row justify="center">
                        <v-col
                          cols="12"
                          lg="5"
                        >
                          <v-btn
                            class="v-btn--block"
                            :color="corPrimaria"
                            small
                            @click="salvar()"
                          >
                            Registrar
                          </v-btn>
                          <span :style="styleObject">
                            Já é cadatrado
                            <router-link
                              to="/login"
                              :style="styleObject"
                            >retorne para fazer o login</router-link>
                          </span>
                        </v-col>
                      </v-row>
                    </div>
                    <v-row>
                      <v-checkbox
                        v-model="politica_privacidade"
                        :rules="[v => !!v || 'Você deve concordar para continuar!']"
                        required
                        :style="styleObject"
                      >
                        <template v-slot:label>
                          <div>
                            Eu li e concordo com os Termos da
                            <a
                              href="https://www.magistech.com.br/politica-de-privacidade/"
                              target="_blank"
                              :style="styleObject"
                              @click.stop
                            >
                              Política de Privacidade.
                            </a>
                          </div>
                        </template>
                      </v-checkbox>
                    </v-row>
                    <v-row
                      v-if="!cadastrook"
                      justify="center"
                    >
                      <v-col
                        cols="12"
                        lg="6"
                      >
                        <div
                          v-if="exibeProgress"
                          class="text-center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="primary"
                          />
                        </div>
                        <v-btn
                          v-else
                          small
                          class="v-btn--block"
                          :disabled="!valid || invalid"
                          default
                          min-width="180"
                          type="submit"
                          :color="corPrimaria"
                        >
                          Registrar
                        </v-btn>
                        <span>
                          Já é cadatrado
                          <router-link
                            to="/login"
                            :style="styleObject"
                          >retorne para fazer o login</router-link>
                        </span>
                      </v-col>
                    </v-row>
                    <base-material-snackbar
                      v-model="snackbar.visible"
                      :timeout="snackbar.timeout"
                      :top="true"
                      :type="snackbar.color"
                    >
                      {{ snackbar.message }}
                    </base-material-snackbar>
                  </v-form>
                </validation-observer>
              </div>
            </div>
          </v-card>
        </v-slide-y-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Usuario from '../../services/usuario'
  import utils from '../../services/utils'
  export default {

    name: 'PageUsuario',

    components: {
      PagesHeading: () => import('./components/Heading'),
    },
    mixins: [utils],

    data: () => ({
      exibePf: true,
      valid: false,
      invalid: true,
      imagem: localStorage.imagem,
      timeoutHandle: null,
      exibeReenviarCodigo: false,
      exibeProgress: false,
      usuario: {
        id: '',
        nome: '',
        email: '',
        cpf: '',
        cnpj: '',
        platform: '',
        osname: 'unknown',
        token: '',
        username: '',
        tokencontrato: '',
        cadastrarcliente: false,
      },
      nomeEmpresa: '',
      tokenencontrato: '',
      cadastrook: false,
      errors: [],
      emailRules: [
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail é obrigatório',
      ],
      ativarUsuario: '',
      // codigoativacaotemp: '',
      maskcpf: '###.###.###-##',
      maskcnpj: '##.###.###/####-##',
      maskphone: '(##)#####-####',
      nomeRules: [
        v => !!v || 'O nome é obrigatório',
      ],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: '',
        timeout: 3000,
      },
      dialog: {
        visible: false,
        message: '',
      },
      corPrimaria: localStorage.corPrimaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      countDown: 0,
      minutes: 4,
      seconds: '00',
      politica_privacidade: false,
      loading: false,
      msgEnvio: '',
      usuarioInativo: '',
      usuarioBloqueado: false,
      whatsapp: 'https://api.whatsapp.com/send?phone=55' + localStorage.whatsapp,
      inputType: false,
      inputType1: false,
    }),

    mounted () {
      this.valid = false
      this.invalid = true

      this.tokenencontrato = localStorage.tokencontrato

      if (this.tokenencontrato !== this.$route.params.tokencontrato) {
        this.$route.params.tokencontrato = this.tokenencontrato
      }

      if (localStorage.getItem('cadastrook')) {
        this.cadastrook = (localStorage.getItem('cadastrook') === 'true')
        if (this.cadastrook) {
          this.reiniciaContador()
        }
      }

      Usuario.verificaEmpresa(this.tokenencontrato).then(resposta => {
        this.nomeEmpresa = resposta.data.empresa
      }).catch(e => {
        if (e.data.errors === 'Empresa não encontrada') {
          this.nomeEmpresa = ''
          this.showSnackbar('error', 3000, 'Empresa não encontrada.')
        }
      })

      if (window.location.href !== 'http://localhost:8080/registrar' && window.location.href !== 'http://192.168.1.22:8080/registrar' && window.location.href !== 'https://magisvendasweb.com.br/registrar' && window.location.href !== 'http://vendas.magisteste/registrar') {
        this.ativarUsuario = window.location.href
        console.log('aqui')
      }

      if (this.ativarUsuario) {
        Usuario.ativarUsuario(this.ativarUsuario).then(resposta => {
          this.nomeEmpresa = resposta.data.empresa

          console.log('aqui metodo')

          this.tokencontrato = resposta.data.token

          localStorage.setItem('tokencontrato', resposta.data.token)
          localStorage.setItem('imagem', 'https://vendas.magisprodutor.com.br/imagens/' + resposta.data.imagem)
          localStorage.setItem('corPrimaria', resposta.data.corPrimaria)

          this.coresBasesSite()

          this.$router.push('/login')

          this.showSnackbar('success', 3000, 'Usuário ativado com sucesso!')
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
          }
          this.$router.push('/registrar')
        })
      }

      this.carregaInfoSistemaOperacional()
      this.carregaMsgEnvio()
      this.verificaVersao()
    },

    methods: {
      reload () {
        location.reload()
      },

      salvar () {
        this.exibeProgress = true
        this.msgEnvio = ''
        this.usuario.osname = localStorage.osname
        if (localStorage.token && localStorage.token !== '') {
          this.usuario.token = localStorage.token
        }
        if (localStorage.platform && localStorage.platform !== '') {
          this.usuario.platform = localStorage.platform
        } else {
          this.usuario.platform = 'unknown'
        }

        if (this.usuario.cpf !== '') {
          this.usuario.username = this.usuario.cpf
        } else {
          this.usuario.username = this.usuario.cnpj
        }

        this.usuario.tokencontrato = this.$route.params.tokencontrato

        this.loading = true
        if (this.$refs.form.validate()) {
          var url = window.location.href
          Usuario.registrar(this.usuario, url).then(resposta => {
            if (resposta.data.status === 'novo-cliente') {
              this.cadastrook = true
              this.usuario.cadastrarcliente = true
              this.nomeEmpresa = resposta.data.nome_empresa
              this.showSnackbar('success', 3000, 'Usuário cadastrado com sucessso, foi enviado um email com link de ativação do cadastro')
            } else if (resposta.data.result === 'cadastro-usuario-ok') {
              this.showSnackbar('success', 3000, 'Usuário cadastrado com sucessso, foi enviado um email com link de ativação do cadastro')
              this.usuarioBloqueado = false
              this.$router.push('/login')
              this.limparDadosForm()
            } else if (!resposta.data.status) {
              this.showSnackbar('false', 3000, resposta.data.inativo)
              this.usuarioInativo = resposta.data.inativo
              this.usuarioBloqueado = true
            }

            this.reiniciaContador()
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            } else if (e.data.message === 'Usuário já cadastrado') {
              this.showSnackbar('error', 3000, ' Dados de usuarário já cadastrados')
            } else if (e.data.message === 'ERRO USUARIO:  Senhas não conferem') {
              this.showSnackbar('error', 3000, 'Senhas não conferem')
            } else if (e.data.message === 'ERRO USUARIO: campo CPF informado inválido') {
              this.showSnackbar('error', 3000, 'CPF informado inválido')
            } else if (e.data.message === 'ERRO USUARIO: campo CNPJ informado inválido') {
              this.showSnackbar('error', 3000, 'CNPJ informado inválido')
            } else if (e.response.data.errors) {
              this.errors = e.response.data.errors
            } else if (e.response.data.status) {
              // erro não tratado
              this.showSnackbar('error', 3000, e.response.data.status + ' - Erro ao registrar')
            } else {
              this.showSnackbar('error', 3000, ' Ocorreu um erro ao registrar')
            }
          }).finally(f => { this.exibeProgress = false })
        }
      },

      coresBasesSite () {
        /* Código apenas para teste mudança de cores */
        if (localStorage.corPrimaria === '#9C27b0') {
          localStorage.setItem('corSecondaria', '#00bcd4')
          localStorage.setItem('corError', '#ff9800')
        } else if (localStorage.corPrimaria === '#2863af') {
          localStorage.setItem('corSecondaria', '#1B5E20')
          localStorage.setItem('corError', '#FF3D00')
        } else if (localStorage.corPrimaria === '#45a048') {
          localStorage.setItem('corSecondaria', '#2863af')
          localStorage.setItem('corError', '#ff5252')
        } else if (localStorage.corPrimaria === '#ff9800') {
          localStorage.setItem('corSecondaria', '#2E7D32')
          localStorage.setItem('corError', '#D32F2F')
        } else if (localStorage.corPrimaria === '#E91E63') {
          localStorage.setItem('corSecondaria', '#009688')
          localStorage.setItem('corError', '#ff5722')
        } else if (localStorage.corPrimaria === '#FF5252') {
          localStorage.setItem('corSecondaria', '#2979FF')
          localStorage.setItem('corError', '#8D6E63')
        } else if (localStorage.corPrimaria === '#D50000') {
          localStorage.setItem('corSecondaria', '#B2DFDB')
          localStorage.setItem('corError', '#F57F17')
        }
      },

      carregaMsgEnvio () {
        if (localStorage.telefone) {
          this.usuario.telefone = localStorage.telefone
        }
        if (localStorage.email && localStorage.email.length > 0) {
          this.usuario.email = localStorage.email
        }
      },

      limparDadosForm () {
        for (this.usuario in this.usuario) {
          this.usuario[this.usuario] = ''
        }
      },

      reenviarCodigo () {
        this.cadastrook = true
        localStorage.setItem('cadastrook', true)
        this.exibeReenviarCodigo = false
        // reinicia contador
        this.reiniciaContador()
        // reenvia codigo de ativacao
        if (localStorage.chaveativacao) {
          Usuario.reenviaCodigoAtivacao(localStorage.chaveativacao).then(resposta => {
            // esconde botao
            this.exibeReenviarCodigo = false
          }).catch(e => {
            this.errors = e.response.data.errors
            // this.limpaDadosOffline()
            this.exibeReenviarCodigo = true
          })
        } else {
          this.limpaDadosOffline()
        }
      },

      reiniciaContador () {
        this.countDown = 0
        this.minutes = 4
        this.seconds = '00'
        clearTimeout(this.timeoutHandle)
        this.countDownTimer()
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      showDialog (message) {
        this.dialog.visible = true
        this.dialog.message = message
      },

      countDownTimer () {
        if (this.minutes >= 0) {
          this.timeoutHandle = setTimeout(() => {
            if (this.countDown === 0 && this.minutes > 0) {
              this.countDown = 60
              this.minutes -= 1
            }
            if (this.countDown > 0) {
              this.countDown -= 1
              if (this.countDown < 10) {
                this.seconds = '0' + this.countDown
              } else {
                this.seconds = this.countDown
              }
              this.countDownTimer()
            } else {
              this.exibeReenviarCodigo = true
            }
          }, 1000)
        }
      },

      limpaDadosOffline () {
        localStorage.removeItem('chaveativacao')
        localStorage.setItem('cadastrook', false)
        this.cadastrook = false
      },

      salvaDadosOffline () {
        // Dados do usuario =========================================v
        localStorage.nome = this.usuario.nome
        localStorage.cpf = this.usuario.cpf
        localStorage.cnpj = this.usuario.cnpj
        localStorage.telefone = this.usuario.telefone
        localStorage.email = this.usuario.email
        localStorage.datanascimento = this.usuario.datanascimento
        localStorage.tokencontrato = this.tokencontrato
        // Dados do usuario =========================================^
      },

      carregaDadosOffline () {
        // Dados do usuario Offline =========================================v
        if (localStorage.nome) {
          this.usuario.nome = localStorage.nome
        }

        if (localStorage.cpf) {
          this.usuario.cpf = localStorage.cpf
        }

        if (localStorage.cnpj) {
          this.usuario.cnpj = localStorage.cnpj
        }

        if (localStorage.telefone) {
          this.usuario.telefone = localStorage.telefone
        }

        if (localStorage.email) {
          this.usuario.email = localStorage.email
        }

        if (localStorage.datanascimento) {
          this.usuario.datanascimento = localStorage.datanascimento
        }
        if (localStorage.cadastrook) {
          this.cadastrook = (localStorage.cadastrook === 'true')
        }
        // Dados do usuario Offline =========================================^
      },

      exibePessoa (value) {
        if (value === 'f') {
          this.exibePf = true
          this.usuario.cnpj = ''
        } else {
          this.exibePf = false
          this.usuario.cpf = ''
        }
      },
    },
  }
</script>

<style lang="sass">
.v-text-field input
  font-size: 1.2em

#register
  .v-list-item__subtitle
    -webkic-line-clamp: initial
    -webkit-box-orient: initial

  #imagem
    margin-left: 25%
    margin-right: 25%
    width: 40%
    height: 40%

</style>

<style scoped>
/* .video-container {
    overflow: hidden;
    position: relative;
    width:100%;
}

.video-container::after {
    padding-top: 56.25%;
    display: block;
    content: '';
}

.video-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
} */
</style>
